export default "__VITE_ASSET__3ed7f281__"